export const messages = {
  en: {
    resourceStoreManage: {
      addFirstLevel: 'Add First Level',
      addSecondLevel: 'Add Second Level',
      edit: 'Edit',
      delete: 'Delete',
      queryCondition: 'Query Conditions',
      selectStorehouse: 'Select Storehouse',
      enterResourceName: 'Enter Resource Name',
      enterResourceCode: 'Enter Resource Code',
      selectSpec: 'Select Specification',
      selectIsFixed: 'Select Fixed Resource',
      query: 'Query',
      reset: 'Reset',
      resourceInfo: 'Resource Information',
      add: 'Add',
      directPurchase: 'Direct Purchase Inbound',
      directOut: 'Direct Outbound',
      import: 'Import',
      export: 'Export',
      back: 'Back',
      resourceId: 'Resource ID',
      resourceNameCode: 'Resource Name (Code)',
      storeName: 'Storehouse Name',
      resourceType: 'Resource Type',
      resourceSpec: 'Specification',
      referencePrice: 'Reference Price',
      chargeStandard: 'Charge Standard',
      stock: 'Stock',
      minTotal: 'Min Total',
      avgPrice: 'Avg Price',
      totalPrice: 'Total Price',
      operation: 'Operation',
      subTotal: 'Sub Total',
      grandTotal: 'Grand Total',
      yuan: 'Yuan',
      detail: 'Detail',
      confirmOperation: 'Confirm Operation',
      confirmDeleteResource: 'Confirm to delete resource?',
      cancelDelete: 'Cancel',
      confirmDelete: 'Confirm Delete',
      addResource: 'Add Resource',
      resourceName: 'Resource Name',
      resourceCode: 'Resource Code',
      secondCategory: 'Second Category',
      unit: 'Unit',
      fixedResource: 'Fixed Resource',
      warningStock: 'Warning Stock',
      minUnit: 'Min Unit',
      minUnitTip: '[Example] 1 box of nails has 50 pieces, unit is box (1 box), min unit is piece (50 pieces).',
      minUnitQty: 'Min Unit Quantity',
      minCharge: 'Min Charge (Min Unit)',
      maxCharge: 'Max Charge (Min Unit)',
      initialStock: 'Initial Stock',
      remark: 'Remark',
      description: 'Description',
      uploadImage: 'Upload Image',
      selectResourceType: 'Select Resource Type',
      selectSecondCategory: 'Select Second Category',
      selectUnit: 'Select Unit',
      enterReferencePrice: 'Enter Reference Price',
      enterWarningStock: 'Enter Warning Stock',
      selectMinUnit: 'Select Min Unit',
      enterMinUnitQty: 'Enter Min Unit Quantity',
      enterMinCharge: 'Enter Min Charge',
      enterMaxCharge: 'Enter Max Charge',
      enterInitialStock: 'Enter Initial Stock',
      enterRemark: 'Enter Remark',
      enterDescription: 'Enter Description',
      addSuccess: 'Add Success',
      resourceNameRequired: 'Resource name is required',
      resourceNameLength: 'Resource name length 2-100 characters',
      resourceCodeRequired: 'Resource code is required',
      resourceCodeMaxLength: 'Resource code max length 50 characters',
      resourceTypeRequired: 'Resource type is required',
      secondCategoryRequired: 'Second category is required',
      unitRequired: 'Unit is required',
      isFixedRequired: 'Fixed resource is required',
      storehouseRequired: 'Storehouse is required',
      referencePriceRequired: 'Reference price is required',
      priceFormatError: 'Price format error',
      warningStockRequired: 'Warning stock is required',
      warningStockMin: 'Warning stock min is 0',
      minUnitRequired: 'Min unit is required',
      minUnitQtyRequired: 'Min unit quantity is required',
      minChargeRequired: 'Min charge is required',
      maxChargeRequired: 'Max charge is required',
      chargeFormatError: 'Charge format error',
      initialStockRequired: 'Initial stock is required',
      maxChargeError: 'Max charge cannot be less than min charge',
      editResource: 'Edit Resource',
      updateSuccess: 'Update Success',
      confirmDeleteResourceType: 'Confirm to delete resource type?',
      importResource: 'Import Resource',
      browse: 'Browse',
      selectDataFile: 'Select data file',
      downloadTemplate: 'Download Template',
      downloadTemplateTip1: 'Please download',
      resourceTemplate: 'Resource Template',
      downloadTemplateTip2: 'prepare data, then upload to import',
      importSuccess: 'Import Success',
      fileRequired: 'File is required',
      invalidExcelFormat: 'Invalid Excel format',
      fileSizeLimit: 'File size cannot exceed 2MB',
      addFirstLevelType: 'Add First Level Type',
      addSecondLevelType: 'Add Second Level Type',
      typeName: 'Type Name',
      enterTypeName: 'Enter type name',
      enterTypeDescription: 'Enter type description',
      typeNameRequired: 'Type name is required',
      addTypeSuccess: 'Add type success',
      editResourceType: 'Edit Resource Type',
      updateTypeSuccess: 'Update type success',
      deleteTypeSuccess: 'Delete type success',
      inboundTime: 'Inbound Time',
      unitPrice: 'Unit Price',
      fetchTotalPriceError: 'Failed to get total price details',
      storehouse: 'Storehouse',
      selectType: 'Please select resource type'
    },
    resourceStoreTimes:{
      title: 'Total Price Details',
      itemCode: 'Item Code',
      inboundTime: 'Inbound Time',
      unitPrice: 'Unit Price',
      stock: 'Stock',
      totalPrice: 'Total Price',
    }
  },
  zh: {
    resourceStoreManage: {
      addFirstLevel: '添加一级',
      addSecondLevel: '添加二级',
      edit: '修改',
      delete: '删除',
      queryCondition: '查询条件',
      selectStorehouse: '请选择仓库',
      enterResourceName: '请输入物品名称',
      enterResourceCode: '请输入物品编码',
      selectSpec: '请选择物品规格',
      selectIsFixed: '请选择物品是否固定',
      query: '查询',
      reset: '重置',
      resourceInfo: '物品信息',
      add: '添加',
      directPurchase: '直接采购入库',
      directOut: '直接出库',
      import: '导入',
      export: '导出',
      back: '返回',
      resourceId: '物品ID',
      resourceNameCode: '物品名称(编号)',
      storeName: '仓库名称',
      resourceType: '物品类型',
      resourceSpec: '物品规格',
      fixedResource: '固定物品',
      referencePrice: '参考价格',
      chargeStandard: '收费标准',
      stock: '物品库存',
      minUnit: '最小计量',
      minTotal: '最小计量总数',
      avgPrice: '物品均价',
      totalPrice: '物品总价',
      operation: '操作',
      subTotal: '小计',
      grandTotal: '大计',
      yuan: '元',
      detail: '详情',
      confirmOperation: '请确认您的操作',
      confirmDeleteResource: '确定删除物品管理?',
      cancelDelete: '点错了',
      confirmDelete: '确认删除',
      addResource: '添加物品',
      resourceName: '物品名称',
      resourceCode: '物品编码',
      secondCategory: '二级分类',
      unit: '物品单位',
      warningStock: '警告库存',
      minUnitTip: '【例】1盒钉子50个，物品单位为盒（1盒），最小计量单位为个（50个）',
      minUnitQty: '最小计量数量',
      minCharge: '最低收费标准(最小计量单位)',
      maxCharge: '最高收费标准(最小计量单位)',
      initialStock: '初始库存',
      remark: '备注',
      description: '描述',
      uploadImage: '上传图片',
      selectResourceType: '请选择物品类型',
      selectSecondCategory: '请选择二级分类',
      selectUnit: '请选择物品单位',
      enterReferencePrice: '请输入物品采购参考价格',
      enterWarningStock: '请输入警告库存',
      selectMinUnit: '请选择物品最小计量单位',
      enterMinUnitQty: '请输入最小计量单位数量',
      enterMinCharge: '请输入物品最小计量单位，最低收费标准',
      enterMaxCharge: '请输入物品最小计量单位，最高收费标准',
      enterInitialStock: '请输入出入库存',
      enterRemark: '请填写备注',
      enterDescription: '请填写描述',
      addSuccess: '添加成功',
      resourceNameRequired: '物品名称不能为空',
      resourceNameLength: '物品名称长度为2至100',
      resourceCodeRequired: '物品编码不能为空',
      resourceCodeMaxLength: '物品编码不能超过50位',
      resourceTypeRequired: '物品类型不能为空',
      secondCategoryRequired: '二级分类不能为空',
      unitRequired: '单位不能为空',
      isFixedRequired: '是否是固定物品不能为空',
      storehouseRequired: '仓库不能为空',
      referencePriceRequired: '物品价格不能为空',
      priceFormatError: '物品价格格式错误',
      warningStockRequired: '警告库存不能为空',
      warningStockMin: '警告库存最小为零',
      minUnitRequired: '最小计量单位不能为空',
      minUnitQtyRequired: '最小计量单位数量不能为空',
      minChargeRequired: '最低收费标准不能为空',
      maxChargeRequired: '最高收费标准不能为空',
      chargeFormatError: '收费标准格式错误',
      initialStockRequired: '出入库存不能为空',
      maxChargeError: '最高收费标准不能小于最低收费标准',
      editResource: '修改物品',
      updateSuccess: '修改成功',
      confirmDeleteResourceType: '确定删除物品类型?',
      importResource: '物品导入',
      browse: '浏览',
      selectDataFile: '请选择数据文件',
      downloadTemplate: '下载模板',
      downloadTemplateTip1: '请先下载',
      resourceTemplate: '物品模板',
      downloadTemplateTip2: '准备数据后，上传导入',
      importSuccess: '导入成功',
      fileRequired: '文件不能为空',
      invalidExcelFormat: '不是有效的Excel格式',
      fileSizeLimit: 'Excel文件大小不能超过2M',
      addFirstLevelType: '添加一级类型',
      addSecondLevelType: '添加二级类型',
      typeName: '类型名称',
      enterTypeName: '请填写物品类型名称',
      enterTypeDescription: '请填写物品类型描述',
      typeNameRequired: '类型名称不能为空',
      addTypeSuccess: '添加类型成功',
      editResourceType: '修改物品类型',
      updateTypeSuccess: '修改类型成功',
      deleteTypeSuccess: '删除类型成功',
      inboundTime: '入库时间',
      unitPrice: '单价',
      fetchTotalPriceError: '获取物品总价详情失败',
      storehouse: '仓库',
      selectType: '请选择物品类型'
    },
    resourceStoreTimes:{
      title: '物品总价详情',
      itemCode: '物品编码',
      inboundTime: '入库时间',
      unitPrice: '单价',
      stock: '库存',
      totalPrice: '总价',
    }
  }
}